"use client"

import { useEffect, useState, type ReactNode } from "react"
import { useRouter, usePathname } from "next/navigation"
import { api } from "@/lib/api-client"
import { Shell } from "@/components/layout/shell"

export default function AppLayout({ children }: { children: ReactNode }) {
  const [verified, setVerified] = useState(false)
  const router = useRouter()
  const pathname = usePathname()

  useEffect(() => {
    const { accessToken } = api.getTokens()
    if (!accessToken) {
      const locale = pathname.split("/")[1] || "en"
      router.replace(`/${locale}/login`)
      return
    }
    api.get("/api/v1/users/me").then((res) => {
      if (!res.ok) {
        api.clearTokens()
        const locale = pathname.split("/")[1] || "en"
        router.replace(`/${locale}/login`)
        return
      }
      setVerified(true)
    })
  }, [pathname, router])

  if (!verified) return null
  return <Shell>{children}</Shell>
}
